import {
	type Icon,
	IconBox,
	IconChartDots,
	IconExternalLink,
	IconFileCode,
	IconFolder,
} from "@tabler/icons-vue";
import type { RouteLocationNormalizedLoaded } from "vue-router";

import type { Permission } from "@/stores/workspaces";
import IconGltfEditor from "../../assets/icons/gltf-editor.svg";
import IconShoppingBag from "../../assets/icons/shopping-bag.svg";
import IconWorkspaces from "../../assets/icons/workspaces.svg";

export interface RouteCategory {
	title: string;
	displayFn?: (route: RouteLocationNormalizedLoaded) => boolean;
	children: RouteItem[];
	permissionRequired?: Permission;
}

export interface RouteItem {
	title: string;
	path: string;
	icon?: Icon | string;
	displayFn?: (route: RouteLocationNormalizedLoaded) => boolean;
	displaySubRoutesFn?: (route: RouteLocationNormalizedLoaded) => boolean;
	children?: RouteItem[];
	permissionRequired?: Permission;
}

const navItems: RouteCategory[] = [
	{
		title: "",
		children: [
			{
				title: "Workspaces",
				icon: IconWorkspaces,
				path: "/workspaces",
				displaySubRoutesFn: (route) =>
					typeof route.params === "object" && "workspaceName" in route.params,
				children: [
					{
						title: "Workspace Overview",
						path: "",
					},
				],
			},
		],
	},
	{
		title: "Library",
		displayFn: (route) =>
			typeof route.params === "object" && "workspaceName" in route.params,
		children: [
			{
				title: "Files",
				icon: IconFolder,
				path: "files",
				permissionRequired: "write",
			},
			{
				title: "Projects",
				icon: IconBox,
				path: "projects",
			},
			{
				title: "Products",
				icon: IconShoppingBag,
				path: "products",
			},
		],
	},
	{
		title: "Tools",
		displayFn: (route) =>
			typeof route.params === "object" && "workspaceName" in route.params,
		children: [
			{
				title: "glTF Editor",
				icon: IconGltfEditor,
				path: "editor",
			},
		],
		permissionRequired: "write",
	},
	{
		title: "Insights",
		displayFn: (route) =>
			typeof route.params === "object" && "workspaceName" in route.params,
		children: [
			{
				title: "Analytics",
				icon: IconChartDots,
				path: "analytics",
				displaySubRoutesFn: (route) =>
					route.matched.some((m) => m.name === "Analytics"),
				children: [
					{
						title: "Sessions",
						path: "analytics/sessions",
					},
					{
						title: "Conversions",
						path: "analytics/conversions",
					},
					{
						title: "Products",
						path: "analytics/products",
					},
					{
						title: "Configurations",
						path: "analytics/configurations",
					},
					{
						title: "Preferences",
						path: "analytics/preferences",
					},
					{
						title: "Hotspots",
						path: "analytics/hotspots",
					},
					{
						title: "All Events",
						path: "analytics/all-events",
					},
				],
			},
		],
		permissionRequired: "write",
	},
	{
		title: "Resources",
		children: [
			{
				title: "Documentation",
				icon: IconFileCode,
				path: "https://docs.dopple.io",
			},
			{
				title: "Dopple.io",
				icon: IconExternalLink,
				path: "https://www.dopple.io",
			},
		],
	},
];

export { navItems };
